import common from '@page/common/js/common';

require('@global/vendors/jquery.sticky-kit');

import Pagination from '@global/components/global/Pagination';
import switchTmpl from '@page/shop/js/switchTmpl';

import Slick from '@global/vendors/vue-slick';

import WishBtn from '@page/shop/components/WitshBtn';
import FilterProduct from '@page/shop/components/FilterProduct';

import fireShopListViewEvent from '@global/gtm/shopList/shopListView';
import fireShopListClickGTMEvent from '@global/gtm/shopList/clickList';

new Vue({
  el: '#pagination',
  template: `<Pagination></Pagination>`,
  components: {
    Pagination,
  },
  mounted() {},
});

const gridMode = {
  template: switchTmpl,
  props: ['largemode', 'mode'],
  data: function () {
    return {
      largeMode: this.largemode,
    };
  },
  methods: {
    switchMode: function (mode) {
      this.largeMode = mode;
      this.$emit('changegrid', mode);
    },
  },
};

new Vue({
  el: '#app-shop',
  components: {
    WishBtn,
    FilterProduct,
    gridMode,
  },
  data: {
    largeMode: false,
    bannerSliderConfig: {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      speed: 800,
      autoplay: false,
      autoplaySpeed: 6000,
    },
  },
  mounted: function () {
    if ($('.banner-slide').length) {
      $('.banner-slide').slick(this.bannerSliderConfig);
    }
  },
  created: function () {},
  methods: {
    swichGridMode: function (lMode) {
      this.largeMode = lMode;
    },
    fireGTM(customMarketID, size) {
      console.log(customMarketID, size);
      fireShopListClickGTMEvent({ customMarketID, size });
    },
  },
});

fireShopListViewEvent();

if ($('.item-box').length > 3) {
  $('#category-sidebar').stick_in_parent({ offset_top: 200 });
}
